export const getErrorMessage = error => {
  return (
    error?.data?.detail ||
    error?.data?.title ||
    error?.data?.error ||
    error?.message
  );
};
